import { render, staticRenderFns } from "./AIchat.vue?vue&type=template&id=19fbaedc&scoped=true"
import script from "./AIchat.vue?vue&type=script&lang=js"
export * from "./AIchat.vue?vue&type=script&lang=js"
import style0 from "./AIchat.vue?vue&type=style&index=0&id=19fbaedc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fbaedc",
  null
  
)

export default component.exports